import college from "../../Assets/images/Capture.PNG"
import food from "../../Assets/images/Capture2.PNG"
import password from "../../Assets/images/Capture8.PNG"
import search from "../../Assets/images/Capture4.PNG"
import startup from "../../Assets/images/Capture5.PNG"
import pos from "../../Assets/images/Capture6.PNG"
import port from "../../Assets/images/Capture7.PNG"
import emp from "../../Assets/images/emp.png"
import empS from "../../Assets/images/emp-c.jpg"
import scard from "../../Assets/images/Capture9.PNG"

export const portFolioData = [
    {
        id:1,
        img:college,
        projectName:'IICS Collage',
        desc:"It's a static college website using HTML, CSS and Javascript.",
        projectLink:"https://varsha-chaubey.github.io/iics-college/",
        // sourceCode:"https://github.com/Varsha-Chaubey/IICS-College",
        status:"",
    },
    {
        id:2,
        img:food,
        projectName:"Food Book",
        desc:"It's a static food blog website using HTML, CSS and Javascript.",
        projectLink:"https://varsha-chaubey.github.io/foodblog/",
        // sourceCode:"https://github.com/Varsha-Chaubey/foodblog",
        status:"",
    },
    {
        id:3,
        img:port,
        projectName:"Portfolio",
        desc:"I have developed a portfolio web application using React to showcase my skills and work experience. This interactive platform provides a glimpse into my projects, highlighting the technologies I've worked with and my professional journey.",
        projectLink:"http://varsha-chaubey.vercel.app",
        // sourceCode:"https://github.com/Varsha-Chaubey/search-clone",
        status:"",
    },
    {
        id:4,
        img:empS,
        projectName:"Employee Management Backend",
        desc:"Node.js and Express backend with MongoDB. Implemented CRUD APIs for seamless frontend-backend communication.",
        projectLink:"",
        sourceCode:"https://github.com/Varsha-Chaubey/employee-management-server",
        status:"",
    },
    {
        id:5,
        img:emp,
        projectName:" Employee Management Frontend",
        desc:"React-based frontend for employee management. CRUD operations for adding, deleting, updating, and listing employees",
        projectLink:"",
        sourceCode:"https://github.com/Varsha-Chaubey/employee-management-client",
        status:"",
    },
    {
        id:6,
        img:password,
        projectName:"Password Generator",
        desc:"React-based password generator with user-customizable options. Utilized useCallback, useRef, and useEffect for state management. Feature to copy generated passwords for ease of use.",
        projectLink:"",
        sourceCode:"https://github.com/Varsha-Chaubey/passwordgenerator",
        status:"",
    },
    
    {
        id:7,
        img:scard,
        projectName:" Shopping App",
        desc:"React project with Redux for state management. Thunk middleware for asynchronous actions. Added functionalities for cart manipulation",
        projectLink:"",
        sourceCode:"https://github.com/Varsha-Chaubey/shopingcard",
        status:"",
    },
   
    {
        id:8,
        img:search,
        projectName:"Searchthing",
        desc:"It's a search engine using React and wikipedia search api.We can search any thing and see fined search result counts and can also check wikipedia of that perticular search.",
        projectLink:"",
        sourceCode:"https://github.com/Varsha-Chaubey/search-clone",
        status:"",
    },
    {
        id:9,
        img:startup,
        projectName:"Start Up",
        desc:"A simple web app using React JS, Bootsrap and Javascript functionality.",
        projectLink:"",
        sourceCode:"https://github.com/Varsha-Chaubey/reactstartupwebsite",
        status:"",
    },
    {
        id:10,
        img:pos,
        projectName:"POS App",
        desc:"A POS (Point of Sale) receipt generator built with ReactJS, featuring robust functionality. This application allows users to seamlessly generate receipts for transactions at a point of sale.",
        projectLink:"",
        sourceCode:"https://github.com/Varsha-Chaubey/pos-app",
        status:"Not Done Yet",
    },
    // {
    //     id:7,
    //     img:todo,
    //     projectName:"Todo List",
    //     projectLink:"",
    //     sourceCode:"",
    //     status:"Not Completed Yet",
    // },   
    
    // {
    //     id:'',
    //     img:"",
    //     projectName:"",
    //     projectLink:"",
    //     sourceCode:"",
    //     status:"",
    // },
    // {
    //     id:'',
    //     img:"",
    //     projectName:"",
    //     projectLink:"",
    //     sourceCode:"",
    //     status:"",
    // },
    // {
    //     id:'',
    //     img:"",
    //     projectName:"",
    //     projectLink:"",
    //     sourceCode:"",
    //     status:"",
    // },

]